//Pusher.logToConsole = true;

var pusher = new Pusher('c3a62f6331e2e8f12695', {
    cluster: 'eu',
    encrypted: true
});

const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
};
const currentDate = new Date();

var channel = pusher.subscribe('my-channel');
channel.bind('my-event', function (data) {
    if ((window.user_sip == data.sip || data.sip == 'all') && data.app_url == APP_URL) {
        $.easyAlert({
            'message': '<div class="text-center text-uppercase"><b>Входящий звонок: ' + data.message + '</b></div><br><div class="row text-center"><div class="col-xs-6"><a href="' + 'https://' + window.location.hostname + '/admin/tours?status=active&incomming_phone=' + data.number + '"><b>Бронировать</b></a></div><div class="col-xs-6"><a href="' + 'http://' + window.location.hostname + '/admin/orders?phone=' + data.number + '&date=' + formatDate(currentDate) + '"><b>Все брони клиента</b></a></div></div>',
            'alertType': data.type,
            'position': "t c",
            globalMinWidth: '400px',
            clickToHide: true,
            autoHide: true,
            time: data.time_show * 1000,
            showAnimation: 'fade',
            showDuration: 300,
            hideAnimation: 'fade',
            hideDuration: 300,
            globalSpace: 5,
            complete: null,
            clicked: null,
            hidden: null
        });
    }
});
